import React, { useEffect, useState, useRef } from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onChange,
  className = ''
}: TabsProps) {
  const [indicatorStyle, setIndicatorStyle] = useState({
    left: 0,
    width: 0
  });
  const tabsRef = useRef<(HTMLButtonElement | null)[]>([]);
  useEffect(() => {
    const activeIndex = tabs.findIndex(t => t.id === activeTab);
    const activeElement = tabsRef.current[activeIndex];
    if (activeElement) {
      setIndicatorStyle({
        left: activeElement.offsetLeft,
        width: activeElement.offsetWidth
      });
    }
  }, [activeTab, tabs]);
  return <div className={`relative border-b border-slate-200 ${className}`} data-id="element-243">
      <div className="flex space-x-8" role="tablist" data-id="element-244">
        {tabs.map((tab, index) => <button key={tab.id} ref={el => tabsRef.current[index] = el} role="tab" aria-selected={activeTab === tab.id} aria-controls={`panel-${tab.id}`} onClick={() => onChange(tab.id)} className={`
              pb-4 text-sm font-medium transition-colors duration-200 outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 rounded-t-md
              ${activeTab === tab.id ? 'text-teal-600' : 'text-slate-500 hover:text-slate-700'}
            `} data-id="element-245">
            {tab.label}
          </button>)}
      </div>
      <div className="absolute bottom-0 h-0.5 bg-teal-600 transition-all duration-300 ease-out" style={{
      left: `${indicatorStyle.left}px`,
      width: `${indicatorStyle.width}px`
    }} data-id="element-246" />
    </div>;
}